import type { Step } from 'react-joyride'

export const recommendationSteps: Step[] = [
  {
    target: '[data-tour="rec-new-button"]',
    title: 'Start a Recommendation',
    content: 'Click here to begin a new recommendation session. You\'ll fill out a short questionnaire about the farmer\'s operation to generate personalized product suggestions.',
    skipBeacon: true,
    placement: 'bottom',
  },
  {
    target: '[data-tour="rec-search"]',
    title: 'Search & Filter',
    content: 'Use the search bar to find recommendations by farmer name, farm, or consultant. Filter by status or crop type to narrow down results.',
    skipBeacon: true,
    placement: 'bottom',
  },
  {
    target: '[data-tour="rec-table"]',
    title: 'Recommendation Sessions',
    content: 'Each row represents a recommendation session. You can see the farmer, consultant, crops, confidence score, and current status. Click a completed row to view its results.',
    skipBeacon: true,
    placement: 'top',
  },
  {
    target: '[data-tour="rec-new-button"]',
    title: 'The Questionnaire Flow',
    content: 'The recommendation questionnaire guides you through: Farm Info (name, location, sprayer type) \u2192 Crop Selection \u2192 Equipment Details \u2192 Soil Data (optional). The engine then scores products based on the farmer\'s specific needs.',
    skipBeacon: true,
    placement: 'bottom',
  },
  {
    target: '[data-tour="rec-table"]',
    title: 'Understanding Results',
    content: 'Completed recommendations show results organized by crop tab. Each product card includes confidence scores, application rates, and talking points. You can download a PDF report to share with the farmer.',
    skipBeacon: true,
    placement: 'top',
  },
]
